import React from 'react'
import { Tooltip } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { getStatusColorStyles } from '@modules/requirements/requirements.utils'
import { ShowConditionally } from '@shared/components/show-conditionally.component'
import { AuditRequirement, Roles } from '@shared/types'
import { originalIcons } from '@shared/components/icons/icons'
import { useACL } from '@shared/hooks/use-acl.hook'
import { TableRequirement } from '@modules/company-profile/requirements-table.component'

interface Props {
  requirement:
    | (AuditRequirement & { colors: Record<string, string> }) // TODO: remove this
    | TableRequirement
  isPreviewMode: boolean | undefined
}

export const TableStatusIndicatorComponent = ({
  requirement,
  isPreviewMode,
}: Props) => {
  const classes = useStyles()

  const { is } = useACL()

  return (
    <div style={{ display: 'flex' }}>
      <Tooltip title="Status audytora">
        <div
          className={classes.colorCircle}
          style={{
            ...getStatusColorStyles(requirement.colors.auditor),
            marginRight: 10,
          }}
        />
      </Tooltip>
      <ShowConditionally
        when={
          is([Roles.Client, Roles.ClientEditor, Roles.ClientAdministrator]) ||
          Boolean(isPreviewMode)
        }
      >
        <>
          <Tooltip title="Moja ocena">
            <div
              className={classes.colorCircle}
              style={getStatusColorStyles(requirement.colors.client)}
            />
          </Tooltip>
          {requirement.isOutdated ? (
            <Tooltip
              title="Wymaganie prawne uległo zmianie. Zapoznaj się ze zmienionym wymaganiem prawnym."
              aria-label="deprecation-warning"
            >
              <originalIcons.Error className={classes.deprecatedWarning} />
            </Tooltip>
          ) : null}
        </>
      </ShowConditionally>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  deprecatedWarning: {
    marginLeft: 10,
    color: theme.palette.error.main,
  },
  colorCircle: {
    width: '25px',
    height: '25px',
    borderRadius: '50%',
  },
}))
